import { UPLOADING_STATUS, DEFAULT_UPLOAD_QUEUE } from "../constants";
import { getDefaultUploadStates, getWaitingFiles } from "../lib";

const addFiles = (selectedFiles, files, setFiles, setStatus, setIsLoadingStarted, getNextSerial) => {
  const addedFiles = selectedFiles
    .filter((f) => files.findIndex((existing) => existing.file.name === f.name) === -1)
    .map((f) => ({ file: f, serialNumber: getNextSerial() }));
  setFiles([...files, ...addedFiles]);
  setStatus(UPLOADING_STATUS.Initialization);
  setIsLoadingStarted(false);
};

const selectFiles = (e, files, setFiles, setStatus, setIsLoadingStarted, getNextSerial) => {
  const target = e.target;
  addFiles([...target.files], files, setFiles, setStatus, setIsLoadingStarted, getNextSerial);
  setStatus(UPLOADING_STATUS.Initialization);
  setIsLoadingStarted(false);
};


const removeFile = (index, files, setFiles, setStatus, setIsLoadingStarted) => {
  const filteredFiles = files.filter((_, fileIndex) => fileIndex !== index);
  setFiles(filteredFiles);
  if (filteredFiles.length === 0) {
    setStatus(UPLOADING_STATUS.Initialization);
    setIsLoadingStarted(false);
  }
};

const clearAllFiles = (setFiles, setStatus, reset, setIsLoadingStarted) => {
  setFiles([]);
  setStatus(UPLOADING_STATUS.Initialization);
  setIsLoadingStarted(false);
  reset();
};

const uploadFilesHandler = async (
  files,
  setUploadState,
  setUploadQueue,
  setStatus
) => {
  const defaultUploadStates = getDefaultUploadStates(files);
  setUploadState(defaultUploadStates);

  const waitingFiles = getWaitingFiles(files);
  setUploadQueue({
    ...DEFAULT_UPLOAD_QUEUE,
    waiting: waitingFiles,
  });

  setStatus(UPLOADING_STATUS.Loading);
};

export { addFiles, selectFiles, removeFile, clearAllFiles, uploadFilesHandler };
